import { FC } from 'react';

import { useExternalModal } from 'ui/partials/Modal/useModal';
import { cn } from 'utils/helpers';

import Button from '../Button';

interface PROPS {
  disabledBack?: boolean;
  disabledContinue?: boolean;
  onGoBack: () => void;
  onCancel?: () => void;
  item: string;
}

const BackWarningModal: FC<PROPS> = ({
  disabledBack,
  disabledContinue,
  onGoBack,
  onCancel,
  item,
}) => {
  const { hideModal } = useExternalModal();

  return (
    <div>
      <div className="space-y-2.5">
        <p className="text-sm">
          You have unsaved changes in this {item}. If you go back now, your
          changes will be lost.
        </p>
      </div>
      <div
        className={cn(
          'pt-[22px] mt-[22px]',
          'flex justify-end gap-2',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button
          onClick={() => {
            onGoBack();
            hideModal();
          }}
          label="DISCARD CHANGES AND GO BACK"
          intent="destructive"
          disabled={disabledContinue}
          className="flex-1"
        />
        <Button
          onClick={() => {
            hideModal();
            onCancel?.();
          }}
          label="STAY AND CONTINUE EDITING"
          disabled={disabledBack}
          className="flex-1"
          intent="tertiary"
        />
      </div>
    </div>
  );
};

export default BackWarningModal;
